import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    "@global": {
      body: {
        background: "#FFF",
      },
    },
    container: {
      justifyContent: "center",
      position: "relative",
    },
    contentContainer: {
      padding: theme.spacing(4, 1, 0),
      backgroundColor: "#fff",
      borderRadius: 20,
      justifyContent: "center",
      position: "absolute",
      top: "95%",
      zIndex: 5,

      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(2.5, 2.5, 0),
        top: "85%",
      },
      [theme.breakpoints.up("md")]: {
        top: "70%",
      },
    },
  })
);

export default useStyles;
